// extracted by mini-css-extract-plugin
export var children = "cEqbMrhuDNZqd0ppXdAd";
export var root = "Dq2h4sDvXxZvJC6sjNZC";
export var root_insideIframe = "YuCho9A7fZRwxjBRt3aj";